// AUTO-GENERATED — do not edit. Source: reviewed Git report_sales_copy raw.intent_pages
// Input: business/ishvaram/data/commerce/report_sales_copy.generated.yaml

export const reportIntentPageSlugs = [
  "annual-forecast",
  "baby-name-report",
  "career-astrology-report",
  "career-report",
  "dosha-remedy-plan",
  "dosha-report",
  "gemstone-report",
  "gochar-report",
  "lal-kitab-report",
  "mahadasha-forecast",
  "marriage-report",
  "muhurat-report",
  "numerology-report",
  "pitra-dosh-report",
  "sade-sati-report",
] as const;
